/**
 * Username sign-in.
 *
 * Firebase password accounts require an email, so an account created with a
 * bare username (see functions/scripts/provision-username-user.ts) is stored
 * under an address on a domain the campaign controls. Nothing is ever mailed
 * there; the person only ever types the username.
 */
export const USERNAME_LOGIN_DOMAIN = "login.arturo-os.com";

export function isUsername(input: string): boolean {
  return input.trim() !== "" && !input.includes("@");
}

export function toLoginEmail(input: string): string {
  const value = input.trim().toLowerCase();
  return isUsername(value) ? `${value}@${USERNAME_LOGIN_DOMAIN}` : value;
}
